<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
  <button mat-raised-button color="primary" (click)="goToAddUser()">
    <mat-icon>add_circle</mat-icon> Adicionar Usuário
  </button>

  <table mat-table [dataSource]="items" class="mat-elevation-z1" style="width: 100%;">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let user"> {{user.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let user"> {{user.name}} </td>
    </ng-container>

    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef>Telefone</th>
      <td mat-cell *matCellDef="let user"> {{api.nineExtra(user.mobile) | mask: api.phoneMask}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let user"> {{user.email}} </td>
    </ng-container>

    <ng-container matColumnDef="business_id">
      <th mat-header-cell *matHeaderCellDef>Empresa</th>
      <td mat-cell *matCellDef="let business"> {{business.business_id}} </td>
    </ng-container>

    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef><strong><u>Editar</u></strong></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          color="primary"
          aria-label="Select the business"
          (click)="editUser()"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
